import { asyncForEach, safeInteropRegister } from "../../api-polyfill/src/common/windowFunctions";
export class ProtocolHandlerService {
    constructor(glue, logger) {
        this.glue = glue;
        this.logger = logger;
        this.listeners = new Set();
        this.mostRecentEvent = {
            command: "",
            config: {}
        };
    }
    async processProtocolHandlerEvent(params, caller) {
        this.logger.debug("protocol-handler - Received protocol handler event", params, "distributing to", this.listeners);
        this.mostRecentEvent = params;
        await asyncForEach(Array.from(this.listeners), async (invoker) => {
            await this.glue.interop.invoke(invoker, params);
        });
        return { handled: true };
    }
    async getProtocolString(params, caller) {
        return this.mostRecentEvent;
    }
    async registerProtocolHandlerTriggered(params, caller) {
        this.logger.debug("protocol-handler - Registering protocol-handler-triggered listener", params?.invoker);
        this.listeners.add(params.invoker);
    }
    async unregisterProtocolHandlerTriggered(params, caller) {
        this.listeners.delete(params.invoker);
    }
    async start() {
        await this.glue.interop.register("FSBL.iocd-protocol-event", safeInteropRegister(async (params, caller) => this.processProtocolHandlerEvent(params, caller), this.logger));
        await this.glue.interop.register("FSBL.System.getProtocolString", safeInteropRegister(async (params, caller) => this.getProtocolString(params, caller), this.logger));
        await this.glue.interop.register("FSBL.Event.add.protocol-handler-triggered", safeInteropRegister(async (params, caller) => this.registerProtocolHandlerTriggered(params, caller), this.logger));
        await this.glue.interop.register("FSBL.Event.remove.protocol-handler-triggered", safeInteropRegister(async (params, caller) => this.unregisterProtocolHandlerTriggered(params, caller), this.logger));
    }
}
